import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { App, Button, Popconfirm, Popover, Space, Tag, message } from 'antd';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { queryKeys } from '../../services/react-query/queryKeys';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { PlusOutlined } from '@ant-design/icons';
import { ModalAppPayorContract } from '../../components/upeosoft/ModalApp/ModalApp';
import {
  cancelPayorContract,
  deletePayorContract,
  getPayorContracts,
} from '../../network/PatientInsurancePolicy';
import { TiCancel } from 'react-icons/ti';
import StatusTag from '../../hooks/StatusHook';

const PayorContract = ({ t }) => {
  const client = useQueryClient();
  const { currentLang } = useSelector((state) => state.user);
  const [searchText, setSearchText] = useState('');
  const [cancel, setCancel] = useState(false);
  const [editId, setEditId] = useState('');
  const [edit, setEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getPayorContracts],
    queryFn: () => getPayorContracts(),
    keepPreviousData: true,
  });
  const handleRemove = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (id) =>
        cancel ? cancelPayorContract(id) : deletePayorContract(id),
      onSuccess: (data) => {
        console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        client.invalidateQueries({
          queryKey: [queryKeys.getPayorContracts],
        });
        message.success(
          data?.message?.message || cancel
            ? 'Cancelled successfully'
            : 'Deleted successfully'
        );
        // message.success('تم الحذف بنجاح');
      },
      onError: () => {
        message.error('حدث خطأ ما');
      },
    }
  );
  const columns = [
    {
      title: currentLang === 'en' ? 'Insurance Company' : 'شركة التأمين',
      dataIndex: 'insurance_payor',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        return String(record.insurance_payor)
          .toLowerCase()
          .includes(value.toLowerCase());
      },
    },
    {
      title: currentLang === 'en' ? 'Posting Date' : 'تاريخ النشر',
      dataIndex: 'posting_date',
    },
    {
      title: currentLang === 'en' ? 'Start Date' : 'تاريخ البدء',
      dataIndex: 'start_date',
    },
    {
      title: currentLang === 'en' ? 'End Date' : 'تاريخ الانتهاء',
      dataIndex: 'end_date',
    },
    {
      title:
        currentLang === 'en' ? 'Default Price List' : 'قائمة السعر الافتراضية',
      dataIndex: 'default_price_list',
    },
    {
      title: currentLang === 'en' ? 'Status' : 'الحالة',
      dataIndex: 'docstatus',
      render: (status) => <StatusTag status={status} />,
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => {
        // console.log('record:', record);
        return (
          <Space>
            <Popover
              placement="top"
              title={t.edit}
              onClick={() => {
                setEdit(true);
                setEditId(record?.name);
                setOpen(true);
              }}
            >
              <Button
                size="small"
                type="primary"
                icon={<MdModeEditOutline />}
              />
            </Popover>
            {/* {
                  record?.docstatus !== 2 && (
                    <Popconfirm
                    title={t.cancelPayorContract}
                    description={t.areYouSure}
                    onConfirm={() => {
                      setCancel(true);
                      handleRemove.mutate(record?.name)
                    } }
                    // onCancel={cancel}
                    okText={t.yes}
                    cancelText={t.no}
                  >
                    <Button
                      size="small"
                      type="primary"
                      // danger
                      style={{ background: 'red' }}
                      icon={<TiCancel />}
                      />
                    </Popconfirm>
                  )
                } */}
            <Popconfirm
              title={t.deletePayorContract}
              description={t.areYouSure}
              onConfirm={() => {
                if (record?.docstatus === 1) {
                  setCancel(true);
                  handleRemove.mutate(record?.name);
                } else {
                  setCancel(false);
                  handleRemove.mutate(record?.name);
                }
              }}
              // onCancel={cancel}
              okText={t.yes}
              cancelText={t.no}
            >
              <Button size="small" type="primary" danger icon={<MdDelete />} />
            </Popconfirm>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => ({
    key: index,
    ...item,
  }));
  return (
    <div className="payor-contract">
      <Heading title={t.Insurances} subTitle={t.PayorContract} path="/" />
      <DynamicTableAnt
        columns={columns}
        data={dataTable}
        loading={isLoading}
        setSearchText={setSearchText}
        Placeholder={t.SearchPayorContract}
        // pathBtn="/add-patient"
        buttonModal={
          <Button
            type="primary"
            onClick={() => {
              setOpen(true);
              setEdit(false);
            }}
          >
            <PlusOutlined
              style={{
                fontSize: '10px',
              }}
            />{' '}
            {t.AddPayorContract}
          </Button>
        }
      />
      <ModalAppPayorContract
        t={t}
        edit={edit}
        record={editId}
        open={open}
        setOpen={setOpen}
      />
    </div>
  );
};

export default PayorContract;
